import { motion } from "framer-motion";
import { Plane, Truck, Ship, Star } from "lucide-react";
import { SHIPPING_TIERS } from "../../lib/site";

const ICONS = { "01": Plane, "02": Truck, "03": Ship };

export const Shipping = ({ onQuote }) => {
  return (
    <section id="shipping" data-testid="shipping-section" className="relative py-24 md:py-32 bg-secondary border-y border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-14 md:mb-20 max-w-3xl">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-primary mb-4">/ 02 — Logistics</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.9]">
            Shipping On<br />Your Terms
          </h2>
          <p className="mt-6 font-body text-base text-muted-foreground">
            Three ways to get your parts and machinery — from urgent air freight to economical bulk shipping.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border border border-border">
          {SHIPPING_TIERS.map((tier, i) => {
            const Icon = ICONS[tier.code];
            return (
              <motion.div
                key={tier.code}
                data-testid={`shipping-tier-${tier.code}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                className={`relative p-8 md:p-10 flex flex-col ${
                  tier.featured ? "bg-primary text-primary-foreground" : "bg-card text-card-foreground"
                }`}
              >
                {tier.featured && (
                  <span className="absolute top-6 right-6 inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.15em] font-bold">
                    <Star size={12} fill="currentColor" /> No.1 Choice
                  </span>
                )}
                <Icon size={32} className={tier.featured ? "text-primary-foreground" : "text-primary"} />
                <span className={`mt-8 font-mono text-xs uppercase tracking-[0.2em] ${tier.featured ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
                  Option {tier.code}
                </span>
                <h3 className="mt-2 font-heading text-2xl md:text-3xl font-bold tracking-tight">{tier.name}</h3>
                <p className="mt-4 font-heading text-5xl md:text-6xl font-black tracking-tighter">{tier.time}</p>
                <p className={`mt-4 font-body text-sm leading-relaxed flex-1 ${tier.featured ? "text-primary-foreground/80" : "text-muted-foreground"}`}>
                  {tier.detail}
                </p>
                <button
                  data-testid={`shipping-quote-${tier.code}`}
                  onClick={() => onQuote()}
                  className={`mt-8 h-11 px-5 font-mono text-xs uppercase tracking-[0.15em] font-semibold transition-colors duration-200 ${
                    tier.featured
                      ? "bg-primary-foreground text-primary hover:bg-background hover:text-foreground"
                      : "border border-border hover:bg-primary hover:text-primary-foreground hover:border-primary"
                  }`}
                >
                  Get This Shipping
                </button>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
